var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStablesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.05 232.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1838.38,
    y1: -1921.15,
    x2: 1838.38,
    y2: -1941.51,
    gradientTransform: "rotate(-41.69 3549.975 1297.047)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ca2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198aad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1825.6,
    y1: -1941.51,
    x2: 1825.6,
    y2: -1952.06,
    gradientTransform: "rotate(-41.69 3549.975 1297.047)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ecc8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51b699"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1824.1,
    y1: -1921.15,
    x2: 1824.1,
    y2: -1941.51,
    gradientTransform: "rotate(-41.69 3549.975 1297.047)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1878a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51b699"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 83.47,
    y1: 25.44,
    x2: 97.21,
    y2: 25.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#043e54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198aad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1838.38,
    y1: -1911.54,
    x2: 1838.38,
    y2: -1922.96,
    gradientTransform: "rotate(-41.69 3549.975 1297.047)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#043e54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17628f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 98.89,
    y1: 66.47,
    x2: 98.89,
    y2: 38.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ca2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198aad"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8ecc8d}.cls-7{fill:#043e54}.cls-9{fill:#198aad}.cls-11{fill:#72c494}.cls-13{fill:#0b455e}.cls-14{fill:#51b699}.cls-15{fill:#b6dc8c}.cls-16{fill:#1878a2}.cls-17{fill:#2ca2a4}.cls-18{fill:#17628f}.cls-19{fill:#033342}.cls-20{fill:#9bd08b}.cls-21{fill:#105477}.cls-22{fill:#02252d}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.06 232.99H8.95v-81.72h64.71C25.26 151.26 0 117.79 0 74.62S34.5 0 76.9 0h103.08v81.5H138.8c11.59 0 71.25 11.45 71.25 74.16 0 55.09-32.62 77.33-82.99 77.33z",
    fill: "#d9e694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M152.6 149.05l-4.11 18.03-11.41 8.9-6.66-2.84 14.19-7.88 7.99-16.21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M119.89 120.88l-24.8 38.9 28.53-9.13-3.73-29.77z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M41.58 94.64l-3.62 4.87 2.23 22.92.9-23.58.49-4.21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M41.09 98.85l7.84 3.79-4.04 1.81 5.77 17.73-10.47.25.9-23.58z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient)",
    d: "M112.67 21.59l7.56 20.53 21.01-21.14-28.57.61z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M141.24 20.98l5.25 10.62 2.92-3.23-8.17-7.39z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M142.77 18.93l-1.53 2.05 8.17 7.39-6.64-9.44z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142.77 18.93l-25.95-1.72 24.42 3.77 1.53-2.05z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M116.82 17.21l-4.15 4.38 28.57-.61-24.42-3.77z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.47 16.53l10.2 5.06 4.15-4.38-14.35-.68z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-2)",
    d: "M102.47 16.53l-5.26 5.49 15.46-.43-10.2-5.06z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M107.5 13.35l-5.03 3.18 14.35.68-9.32-3.86z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M103.87 15.65l-12.34.71 6.07 3.54 2.98-1.39 1.89-1.98 1.4-.88z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M91.53 16.36l12.34-.71 3.63-2.3-15.97 3.01zm-8.06 6.69l13.74-1.03 3.37-3.51-17.11 4.54z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M97.21 22.02l10.96 16.81 4.5-17.24-15.46.43z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-3)",
    d: "M112.67 21.59l-4.5 17.24 12.06 3.29-7.56-20.53z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-4)",
    d: "M83.47 23.05l11.12 5.82 2.62-6.85-13.74 1.03z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-5)",
    d: "M141.24 20.98l-21.01 21.14 26.26-10.52-5.25-10.62z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M120.23 42.12l-12.06-3.29 5.07 9.43 6.99-6.14z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.21 22.02l-2.62 6.85 13.58 9.96-10.96-16.81z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M94.59 28.87L64.41 58.45l25.2-7.1 4.98-22.48z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M94.59 28.87l13.58 9.96-18.56 12.52 4.98-22.48z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108.17 38.83l-3.19 27.64 8.26-18.21-5.07-9.43z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-6)",
    d: "M108.17 38.83L89.61 51.35l15.37 15.12 3.19-27.64z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M81.01 65.86l-16.6-7.41-13.85 12.63 30.45-5.22z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.01 65.86L57.37 96.83l-6.81-25.75 30.45-5.22z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M50.56 71.08l-3.4 19.19 10.21 6.56-6.81-25.75z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.16 90.27l-14.33-7.53 16.52-2.19-2.19 9.72z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M49.35 80.55l-17.73-3.88 1.21 6.07 16.52-2.19z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.62 76.67l-3.41 8.74 4.62-2.67-1.21-6.07z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M28.21 85.41l2.19 21.62 3.4-4.37-.97-19.92-4.62 2.67z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M33.8 102.66l4.37.97-1.21-18.95-4.13-1.94.97 19.92z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M33.8 102.66l-3.4 4.37 6.07 10.94-.97-12.64 8.99 2.68-6.32-4.38-4.37-.97z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M36.47 117.97l9.23 3.15-1.21-13.11-8.99-2.68.97 12.64z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M41.58 94.64l11.56-.58 4.23 2.77-16.28 2.02.49-4.21z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M41.09 98.85l18.89 9.4-2.97-6.93.36-4.49-16.28 2.02z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M40.19 122.43l10.06 8.74.41-8.99-10.47.25z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M50.66 122.18l7.34 2.81.17 11.63-7.92-5.45.41-8.99z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M89.61 51.35l20.68 39.98-5.31-24.86-15.37-15.12z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M110.29 91.33l-20.2-3.94-.48-36.04 20.68 39.98z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.09 87.39l29.8 33.49-9.6-29.55-20.2-3.94z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M81.01 65.86l8.6-14.51-25.2 7.1 16.6 7.41z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M81.01 65.86l9.08 21.53-.48-36.04-8.6 14.51z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#a6d38b",
    d: "M81.01 65.86L57.37 96.83l32.72-9.44-9.08-21.53z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M59.98 108.25l30.11-20.86-32.72 9.44-.36 4.49 2.97 6.93z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.98 108.25l9.63 16.73 1.76-19.29-11.39 2.56z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.37 105.69l18.72-18.3-4.68 17.04-14.04 1.26z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M85.41 104.43l4.68-17.04 29.8 33.49-34.48-16.45z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M119.89 120.88l-29.12 1.99 7.82 32.12 21.3-34.11z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M110.29 91.33l32.94 34.42-23.34-4.87-9.6-29.55z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M90.77 122.87l-5.36-18.44 34.48 16.45-29.12 1.99z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.77 122.87l-21.16 2.11 1.76-19.29 19.4 17.18z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.77 122.87l-21.16 2.11 24.52 11.69-3.36-13.8z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M119.89 120.88l32.71 28.17-9.37-23.3-23.34-4.87z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M119.89 120.88l3.73 29.77 28.98-1.6-32.71-28.17z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M123.62 150.65l20.99 14.61 7.99-16.21-28.98 1.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M123.62 150.65l-15.07 23.96-13.46-14.83 28.53-9.13z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M123.62 150.65l-15.07 23.96 36.06-9.35-20.99-14.61z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M95.09 159.78l7.3 30.13 6.16-15.3-13.46-14.83z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108.55 174.61l7.76 6.39-13.92 8.91 6.16-15.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M108.55 174.61l36.06-9.35-28.3 15.74-7.76-6.39z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M116.31 181l2.51 22.6-16.43-13.69 13.92-8.91z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M102.39 189.91l2.05 15.74 14.38-2.05-16.43-13.69z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M118.82 203.6l-28.53 21.22-4.79-.91 18.94-18.26 14.38-2.05z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M104.44 205.65L75.92 224.6l7.76 3.88 1.82-4.57 18.94-18.26z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M75.92 224.6l-7.54 8.39h15.5l-.2-4.51-7.76-3.88z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M134.25 174.78l11.74 28.33-23.49-25.55 7.92-4.42 3.83 1.64z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M134.25 174.78l2.83 1.2 1.45-1.12 16.94 22.92-9.48 5.33-11.74-28.33z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M145.99 203.11l-12.41 25.37 21.89-30.7-9.48 5.33z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M141.51 198.23l-7.93 30.25 12.41-25.37-4.48-4.88z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M141.51 198.23l-15.24 27.41 7.31 2.84 7.93-30.25z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M126.27 225.64l-5.45 7.35h11.8l.96-4.51-7.31-2.84zm50.52-61.01l-6.86-.83-17.33-14.75 24.19 15.58z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M152.6 149.05l-4.93 10 12.4 15.98-7.47-25.98z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M152.6 149.05l17.33 14.75-6.8 4.47-10.53-19.22z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M163.13 168.27l-10.53-19.22 7.47 25.98 3.06-6.76z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M163.13 168.27l6.11 30.01.69-34.48-6.8 4.47z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M169.93 163.8l13.41 30.07-3.93 16.79-9.48-46.86z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M163.13 168.27l-3.06 6.76 9.17 23.25-6.11-30.01z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M176.79 164.63l6.55 29.24-13.41-30.07 6.86.83z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M169.93 163.8l-.69 34.48 10.17 12.38-9.48-46.86z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M59.98 108.25l30.11-20.86-18.72 18.3-11.39 2.56zm11.39-2.56l14.04-1.26 5.36 18.44-19.4-17.18z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M114.97 128.58l-24.2-5.71 3.36 13.8 20.84-8.09z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M119.89 120.88l-29.12 1.99 24.2 5.71 4.92-7.7z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M94.13 136.67l-24.52-11.69 27.69 24.74-3.17-13.05z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStablesIcon);
export default __webpack_public_path__ + "static/media/stables-icon.4d4c36f6f35bd7aaa54db10753ae6382.svg";
export { ForwardRef as ReactComponent };